export default "__VITE_ASSET__tZ$F7_jl__"